module.exports = __webpack_public_path__ + "87f5b27860ffc77fe00fca5937905c55.svg";